import {Determinant} from "./determinant";
import {SelectOperatorType} from "./select-operator";

export class SelectBoxesDeterminant extends Determinant {

  public booleanValue: boolean;
  public selectValue: string;
  public operator: SelectOperatorType;

}
